import {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {PATHS} from "@/constants/routes";
import {useAuthStore} from "@/store/auth.store";
import ArticleDetailPage from "./ArticleDetailPage";
import NewsListPage from "./NewsListPage";

const pathToArticle = (slug: string) => `/article/${encodeURIComponent(slug)}/v2`;

const useAuthGuard = () => {
  const navigate = useNavigate();
  const status = useAuthStore(state => state.status);
  const hydrate = useAuthStore(state => state.hydrate);

  useEffect(() => {
    if (status === "checking") hydrate();
  }, [status, hydrate]);

  useEffect(() => {
    if (status === "unauthenticated") navigate(PATHS.authLogin, {replace: true});
  }, [status, navigate]);

  return status;
};

export const NewsListRoute = () => {
  const navigate = useNavigate();
  const status = useAuthGuard();

  if (status !== "authenticated") {
    return <main className="min-h-screen w-full bg-[var(--color-bg)]" />;
  }

  return (
    <main className="min-h-screen w-full bg-[var(--color-bg)]">
      <NewsListPage onSelectArticle={article => navigate(pathToArticle(article.slug))} />
    </main>
  );
};

export const ArticleDetailRoute = () => {
  const navigate = useNavigate();
  const {slug} = useParams<{slug: string}>();
  const status = useAuthGuard();

  if (status !== "authenticated") {
    return <main className="min-h-screen w-full bg-[var(--color-bg)]" />;
  }

  return (
    <main className="min-h-screen w-full bg-[var(--color-bg)]">
      <ArticleDetailPage
        slug={slug ?? ""}
        onBack={() => navigate(-1)}
      />
    </main>
  );
};
